module.exports = __webpack_public_path__ + "static/make-it-zero-a2107e500d7f9d76ac8b1ce3a0953764.mp4";